import React, { useState } from 'react'
import { SectionNote } from '../annotations/SectionNote.jsx'

/**
 * Generic track container: header with title, collapse chevron,
 * progress indicator, children (cards), and section-level manager note.
 */
export function ReflectionTrack({
  title,
  children,
  cardCount = 4,
  filledCount = 0,
  sectionNote = '',
  onSectionNoteChange,
  onSuggestSectionNote,
  isManager,
  isShared,
  isReady,
  isClosed,
  employeeName,
}) {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div style={styles.track}>
      <button
        type="button"
        style={styles.header}
        onClick={() => setCollapsed((c) => !c)}
        aria-expanded={!collapsed}
      >
        <h3 style={styles.title}>{title}</h3>
        <span style={styles.progress}>
          {filledCount} of {cardCount} cards have content
        </span>
        <span style={styles.chevron}>{collapsed ? '\u25B6' : '\u25BC'}</span>
      </button>

      {!collapsed && (
        <div style={styles.body}>
          {children}
          <SectionNote
            value={sectionNote}
            onChange={onSectionNoteChange}
            onSuggest={onSuggestSectionNote}
            isManager={isManager}
            isShared={isShared}
            isReady={isReady}
            isClosed={isClosed}
            employeeName={employeeName}
          />
        </div>
      )}
    </div>
  )
}

const styles = {
  track: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: 'none',
    border: 'none',
    padding: '4px 0',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
  },
  title: {
    fontSize: '15px',
    fontWeight: 700,
    color: 'var(--text-primary)',
    margin: 0,
  },
  progress: {
    fontSize: '11px',
    color: 'var(--text-secondary)',
    flex: 1,
  },
  chevron: {
    fontSize: '11px',
    color: 'var(--text-secondary)',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
}
